const UploadGuideLines = () => {
  return (
    <>
      <div>Upload GuideLines</div>
    </>
  )
}

export default UploadGuideLines
